(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["camo-footer"] && !Shopify.designMode) return;
  try {
    (() => {
    const initialize = () => {
      document.querySelectorAll('[data-camo-footer]').forEach(footer => {
        if (footer.dataset.ready) return;
        footer.dataset.ready = 'true';
        const desktop = matchMedia('(min-width: 1025px)');
        const update = () => {
          if (!footer.isConnected) { desktop.removeEventListener('change', update); return; }
          footer.querySelectorAll('.camo-footer__group').forEach(group => {
            group.open = desktop.matches;
            group.querySelector('summary').tabIndex = desktop.matches ? -1 : 0;
          });
        };
        update();
        desktop.addEventListener('change', update);
      });
    };
    initialize();
    document.addEventListener('shopify:section:load', initialize);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["camo-navigation"] && !Shopify.designMode) return;
  try {
    (() => {
    function initNavigation(scope = document) {
      scope.querySelectorAll('[data-camo-desktop]:not([data-camo-ready])').forEach(nav => {
        nav.dataset.camoReady = 'true';
        const groups = [...nav.querySelectorAll('details')];
        let closeTimer;
        let openTimer;
        const close = (except) => groups.forEach(group => { if (group !== except) group.open = false; });
        groups.forEach(group => {
          group.addEventListener('toggle', () => { if (group.open) close(group); });
          group.addEventListener('pointerenter', event => {
            if (event.pointerType !== 'mouse') return;
            clearTimeout(closeTimer);
            clearTimeout(openTimer);
            openTimer = setTimeout(() => { close(group); group.open = true; }, 120);
          });
          group.querySelector('summary').addEventListener('click', () => clearTimeout(openTimer));
          group.addEventListener('pointerleave', event => {
            clearTimeout(openTimer);
            if (event.pointerType === 'mouse') closeTimer = setTimeout(() => { group.open = false; }, 160);
          });
        });
        nav.addEventListener('keydown', event => {
          if (event.key !== 'Escape') return;
          const open = groups.find(group => group.open);
          close();
          open?.querySelector('summary').focus();
        });
        nav.addEventListener('focusout', () => {
          queueMicrotask(() => { if (!nav.contains(document.activeElement)) close(); });
        });
        document.addEventListener('click', event => { if (!nav.contains(event.target)) close(); });
        matchMedia('(min-width: 1200px)').addEventListener('change', () => close());
      });
      scope.querySelectorAll('[data-camo-mobile]:not([data-camo-ready])').forEach(drawer => {
        drawer.dataset.camoReady = 'true';
        const root = drawer.querySelector('[data-camo-root]');
        const back = drawer.querySelector('[data-camo-back]');
        const brand = drawer.querySelector('[data-camo-brand]');
        const title = drawer.querySelector('[data-camo-title]');
        const body = drawer.querySelector('.camo-nav__mobile-body');
        const entries = [...drawer.querySelectorAll('[data-camo-enter]')];
        const panels = [...drawer.querySelectorAll('[data-camo-panel]')];
        let activeEntry;
        function showRoot(restoreFocus = false) {
          root.hidden = false;
          brand.hidden = false;
          back.hidden = true;
          title.hidden = true;
          panels.forEach(panel => { panel.hidden = true; });
          entries.forEach(entry => entry.setAttribute('aria-expanded', 'false'));
          body.scrollTop = 0;
          if (restoreFocus) activeEntry?.focus();
        }
        entries.forEach(entry => entry.addEventListener('click', () => {
          const panel = panels.find(item => item.dataset.camoPanel === entry.dataset.camoEnter);
          if (!panel) return;
          activeEntry = entry;
          root.hidden = true;
          brand.hidden = true;
          back.hidden = false;
          title.hidden = false;
          title.textContent = entry.querySelector('span').textContent;
          panels.forEach(item => { item.hidden = item !== panel; });
          entry.setAttribute('aria-expanded', 'true');
          body.scrollTop = 0;
          back.focus();
        }));
        back.addEventListener('click', () => showRoot(true));
        drawer.querySelector('[data-camo-close]').addEventListener('click', () => document.querySelector('.js-mobile-header-main-toggler')?.click());
        new MutationObserver(() => { if (!drawer.classList.contains('is-active')) showRoot(); }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initNavigation());
    else initNavigation();
    document.addEventListener('shopify:section:load', event => initNavigation(event.target));
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-also-available"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('also-available-carousel')) {
		class AlsoAvailableCarousel extends HTMLElement {
			connectedCallback() {
				if (this.hasLoaded) return;

				this.hasLoaded = true;
				this.list = this.querySelector('[data-also-available-list]');
				this.previousButton = this.querySelector('[data-also-available-previous]');
				this.nextButton = this.querySelector('[data-also-available-next]');
				this.currentProductId = this.dataset.currentProductId;
				this.currentProductPrice = Number(this.dataset.currentProductPrice);
				this.designTag = (this.dataset.designTag || '').trim().toLowerCase();
				this.taggedProductsUrl = this.dataset.taggedProductsUrl;

				if (!this.list || !this.previousButton || !this.nextButton || !this.designTag || !this.taggedProductsUrl) {
					this.remove();
					return;
				}

				this.updateControls = this.updateControls.bind(this);
				this.handleScroll = this.handleScroll.bind(this);
				this.handlePointerDown = this.handlePointerDown.bind(this);
				this.handlePointerMove = this.handlePointerMove.bind(this);
				this.handlePointerEnd = this.handlePointerEnd.bind(this);
				this.handleClick = this.handleClick.bind(this);
				this.handleDragStart = this.handleDragStart.bind(this);
				this.previousButton.addEventListener('click', () => this.scroll(-1));
				this.nextButton.addEventListener('click', () => this.scroll(1));
				this.list.addEventListener('scroll', this.handleScroll, { passive: true });
				this.list.addEventListener('pointerdown', this.handlePointerDown);
				this.list.addEventListener('pointermove', this.handlePointerMove);
				this.list.addEventListener('pointerup', this.handlePointerEnd);
				this.list.addEventListener('pointercancel', this.handlePointerEnd);
				this.list.addEventListener('click', this.handleClick, true);
				this.list.addEventListener('dragstart', this.handleDragStart);
				this.resizeObserver = new ResizeObserver(this.updateControls);
				this.resizeObserver.observe(this.list);
				this.abortController = new AbortController();
				this.loadProducts();
			}

			disconnectedCallback() {
				if (this.abortController) this.abortController.abort();
				if (this.resizeObserver) this.resizeObserver.disconnect();
				if (this.list && this.handleScroll) this.list.removeEventListener('scroll', this.handleScroll);
				if (this.list && this.handlePointerDown) this.list.removeEventListener('pointerdown', this.handlePointerDown);
				if (this.list && this.handlePointerMove) this.list.removeEventListener('pointermove', this.handlePointerMove);
				if (this.list && this.handlePointerEnd) {
					this.list.removeEventListener('pointerup', this.handlePointerEnd);
					this.list.removeEventListener('pointercancel', this.handlePointerEnd);
				}
				if (this.list && this.handleClick) this.list.removeEventListener('click', this.handleClick, true);
				if (this.list && this.handleDragStart) this.list.removeEventListener('dragstart', this.handleDragStart);
			}

			async loadProducts() {
				try {
					const response = await fetch(this.taggedProductsUrl, {
						headers: { 'X-Requested-With': 'XMLHttpRequest' },
						signal: this.abortController.signal
					});

					if (!response.ok) throw new Error(`Unable to load related products: ${response.status}`);

					const responseDocument = new DOMParser().parseFromString(await response.text(), 'text/html');
					const products = [...responseDocument.querySelectorAll('[data-also-available-product]')]
						.filter((relatedProduct) => relatedProduct.dataset.productId !== this.currentProductId)
						.filter((relatedProduct) => this.hasMatchingDesignTag(relatedProduct.dataset.productTags));

					if (!products.length) {
						this.remove();
						return;
					}

					products.forEach((relatedProduct) => this.updatePriceDifference(relatedProduct));
					this.list.replaceChildren(...products);
					this.list.setAttribute('aria-busy', 'false');
					this.hidden = false;
					requestAnimationFrame(this.updateControls);
				} catch (error) {
					if (error.name !== 'AbortError') this.remove();
				}
			}

			hasMatchingDesignTag(tagsJson) {
				try {
					const tags = JSON.parse(tagsJson || '[]');
					return tags.some((tag) => tag.trim().toLowerCase() === this.designTag);
				} catch (error) {
					return false;
				}
			}

			updatePriceDifference(relatedProduct) {
				const relatedPrice = Number(relatedProduct.dataset.productPrice);
				const priceDifference = relatedPrice - this.currentProductPrice;
				const differenceElement = relatedProduct.querySelector('[data-price-difference]');

				if (!differenceElement || !Number.isFinite(priceDifference) || priceDifference <= 0) return;

				differenceElement.textContent = `+${this.formatMoney(priceDifference)}`;
				differenceElement.hidden = false;
			}

			formatMoney(cents) {
				const formatMoney = window.themeCore?.utils?.formatMoney;
				const moneyFormat = window.themeCore?.objects?.shop?.money_format;

				if (typeof formatMoney === 'function' && moneyFormat) return formatMoney(cents, moneyFormat);

				const currency = window.Shopify?.currency?.active || window.themeCore?.objects?.currency?.cart || 'USD';
				return new Intl.NumberFormat(document.documentElement.lang || 'en', {
					currency,
					style: 'currency'
				}).format(cents / 100);
			}

			scroll(direction) {
				this.list.scrollBy({ left: direction * this.list.clientWidth, behavior: 'smooth' });
			}

			handleScroll() {
				cancelAnimationFrame(this.scrollFrame);
				this.scrollFrame = requestAnimationFrame(this.updateControls);
			}

			handlePointerDown(event) {
				if (event.pointerType !== 'mouse' || event.button !== 0) return;

				this.isDragging = true;
				this.dragged = false;
				this.dragStartX = event.clientX;
				this.dragStartScroll = this.list.scrollLeft;
				this.list.classList.add('is-dragging');
			}

			handlePointerMove(event) {
				if (!this.isDragging) return;

				const distance = event.clientX - this.dragStartX;
				if (Math.abs(distance) > 4 && !this.dragged) {
					this.dragged = true;
					this.list.setPointerCapture(event.pointerId);
				}
				this.list.scrollLeft = this.dragStartScroll - distance;
			}

			handlePointerEnd(event) {
				if (!this.isDragging) return;

				if (this.list.hasPointerCapture(event.pointerId)) this.list.releasePointerCapture(event.pointerId);
				this.isDragging = false;
				this.list.classList.remove('is-dragging');
				if (event.type === 'pointercancel') this.dragged = false;
				requestAnimationFrame(this.updateControls);
			}

			handleClick(event) {
				if (!this.dragged) return;

				event.preventDefault();
				event.stopPropagation();
				this.dragged = false;
			}

			handleDragStart(event) {
				event.preventDefault();
			}

			updateControls() {
				const maximumScroll = Math.max(0, this.list.scrollWidth - this.list.clientWidth);
				this.previousButton.hidden = this.list.scrollLeft <= 2;
				this.nextButton.hidden = this.list.scrollLeft >= maximumScroll - 2;
			}
		}

		customElements.define('also-available-carousel', AlsoAvailableCarousel);
	}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    if (!window.productCardReferenceListener) {
			window.productCardReferenceListener = true;
			document.addEventListener('click', function (event) {
				var toggle = event.target.closest('.js-product-card-swatches-toggle');
				if (toggle) {
					var swatches = toggle.closest('.js-product-card-swatches');
					if (swatches) {
						swatches.classList.add('is-expanded');
						toggle.setAttribute('aria-expanded', 'true');
					}
					return;
				}

				var swatch = event.target.closest('.js-product-card-swatch');
				if (!swatch) return;
				var card = swatch.closest('.js-product-card');
				var label = card && card.querySelector('.js-product-card-color-label');
				if (label) {
					var color = (swatch.dataset.swatch || '').toLowerCase();
					label.textContent = color.replace(/\b\w/g, function (letter) { return letter.toUpperCase(); });
				}
			});
		}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-combo3-builder"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('combo-three')) {
    customElements.define('combo-three', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.variants = JSON.parse(this.querySelector('[data-combo3-variants]').textContent);
        this.labels = JSON.parse(this.querySelector('[data-combo3-labels]').textContent);
        this.form = this.querySelector('form');
        const initial = this.variants.find(v => String(v.id) === this.dataset.initialId) || this.variants[0];
        this.state = { choice: initial.option1, sweatshirt: initial.option1 === 'Fleece Christmas Hat' ? 'S' : initial.option2, hat: initial.option1 === 'Fleece Christmas Hat' ? initial.option2 : 'S' };
        this.querySelectorAll('[data-combo3-choice]').forEach(button => button.addEventListener('click', () => { this.state.choice = button.dataset.combo3Choice; this.render(true); }));
        this.querySelectorAll('[data-combo3-size]').forEach(button => button.addEventListener('click', () => { this.state[button.dataset.combo3Size] = button.dataset.size; this.render(false); }));
        this.querySelectorAll('[data-combo3-media]').forEach(button => button.addEventListener('click', () => this.showImage(button)));
        this.form.addEventListener('submit', event => {
          this.render(false);
          if (!this.variant?.available || !this.form.reportValidity()) event.preventDefault();
        });
        this.form.addEventListener('formdata', event => {
          if (this.variant) event.formData.set('id', String(this.variant.id));
        });
        this.render(true);
      }
      money(value) {
        return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency',currency:this.dataset.currency || 'USD'}).format(value / 100);
      }
      showImage(button) {
        const hero = this.querySelector('.combo3__hero');
        hero.removeAttribute('srcset'); hero.src = button.dataset.src;
        hero.alt = button.querySelector('img').alt;
        this.querySelectorAll('[data-combo3-media]').forEach(b => b.setAttribute('aria-pressed',String(b === button)));
      }
      render(changeGallery) {
        const choiceButton = [...this.querySelectorAll('[data-combo3-choice]')].find(b => b.dataset.combo3Choice === this.state.choice);
        const group = choiceButton.dataset.group;
        const isCombo = group === 'combo';
        const size = group === 'hat' ? this.state.hat : this.state.sweatshirt;
        this.variant = this.variants.find(v => v.option1 === this.state.choice && v.option2 === size);
        if (this.variant) this.form.querySelector('[name="id"]').value = this.variant.id;
        this.querySelectorAll('[data-combo3-choice]').forEach(b => b.setAttribute('aria-pressed',String(b === choiceButton)));
        for (const role of ['sweatshirt','hat']) {
          const included = isCombo || group === role;
          this.querySelector('[data-combo3-row="'+role+'"]').hidden = !included;
          const property = this.querySelector('[data-combo3-property="'+role+'"]');
          property.disabled = !isCombo; property.value = this.state[role];
        }
        this.querySelectorAll('[data-combo3-personalize]').forEach(panel => {
          panel.hidden = false;
          panel.querySelectorAll('input, textarea').forEach(input => {input.disabled = false; input.required = true;});
        });
        this.querySelectorAll('[data-combo3-size]').forEach(b => b.setAttribute('aria-pressed',String(b.dataset.size === this.state[b.dataset.combo3Size])));
        const summary = (group !== 'hat' ? this.labels.sweatshirt + ': ' + this.state.sweatshirt : '') + (isCombo ? ' + ' : '') + (group !== 'sweatshirt' ? this.labels.hat + ': ' + this.state.hat : '');
        this.querySelector('[data-combo3-summary]').textContent = summary;
        this.querySelector('[data-combo3-submit]').disabled = !this.variant?.available;
        const error = this.querySelector('[data-combo3-error]');
        error.hidden = !!this.variant?.available; error.textContent = this.labels.unavailable;
        if (this.variant) this.querySelectorAll('[data-combo3-price], [data-combo3-total]').forEach(node => node.textContent = this.money(this.variant.price));
        this.querySelectorAll('[data-combo3-media]').forEach(button => button.hidden = button.dataset.combo3Media !== group);
        if (changeGallery) {
          const first = this.querySelector('[data-combo3-media="'+group+'"]');
          if (first) this.showImage(first);
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-combo3-size-chart"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('combo-three-size-guide')) {
    customElements.define('combo-three-size-guide', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const dialog = this.querySelector('dialog');
        const opener = this.querySelector('[data-chart-open]');
        opener?.addEventListener('click', () => dialog.showModal());
        this.querySelector('[data-chart-close]')?.addEventListener('click', () => dialog.close());
        dialog?.addEventListener('click', event => {
          const rect = dialog.getBoundingClientRect();
          if (event.target === dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) dialog.close();
        });
        dialog?.addEventListener('close', () => opener.focus());
        this.querySelectorAll('[data-chart-product]').forEach(button => button.addEventListener('click', () => {
          this.querySelectorAll('[data-chart-product]').forEach(control => control.setAttribute('aria-pressed', String(control === button)));
          this.querySelectorAll('[data-chart-panel]').forEach(panel => panel.hidden = panel.dataset.chartPanel !== button.dataset.chartProduct);
        }));
        this.querySelectorAll('[data-chart-unit]').forEach(button => button.addEventListener('click', () => {
          this.querySelectorAll('[data-chart-unit]').forEach(control => control.setAttribute('aria-pressed', String(control === button)));
          this.querySelectorAll('[data-chart-table]').forEach(table => table.hidden = table.dataset.chartTable !== button.dataset.chartUnit);
        }));
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-inline-details"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-shipping-timing')) {
    customElements.define('product-shipping-timing', class extends HTMLElement {
      connectedCallback() {
        this.toggle = this.querySelector('button');
        this.timingPanel = this.timingPanel || this.querySelector('.product-shipping-timing__popover');
        if (!this.toggle || !this.timingPanel || this.controller) return;

        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.pinned = false;
        this.timingPanel.hidden = true;
        this.toggle.setAttribute('aria-expanded', 'false');
        // Keep the breakdown outside product containers that clip overflow or use transforms.
        document.body.append(this.timingPanel);

        this.addEventListener('pointerenter', (event) => {
          if (event.pointerType === 'touch') return;
          clearTimeout(this.hideTimer);
          this.show();
        }, options);
        this.addEventListener('pointerleave', (event) => {
          if (event.pointerType === 'touch') return;
          this.scheduleHide();
        }, options);
        this.timingPanel.addEventListener('pointerenter', () => clearTimeout(this.hideTimer), options);
        this.timingPanel.addEventListener('pointerleave', () => this.scheduleHide(), options);
        this.toggle.addEventListener('focus', () => this.show(), options);
        this.toggle.addEventListener('blur', () => this.hide(), options);
        this.toggle.addEventListener('click', (event) => {
          // The estimate is an independent control inside the accordion's summary.
          event.preventDefault();
          event.stopPropagation();
          this.pinned = !this.pinned;
          if (this.pinned) this.show();
          else this.hide();
        }, options);
        this.toggle.addEventListener('keydown', (event) => {
          if (event.key === 'Enter' || event.key === ' ') event.stopPropagation();
        }, options);
        document.addEventListener('pointerdown', (event) => {
          if (this.contains(event.target) || this.timingPanel.contains(event.target)) return;
          this.hide();
        }, { ...options, capture: true });
        document.addEventListener('keydown', (event) => {
          if (event.key !== 'Escape' || this.timingPanel.hidden) return;
          this.hide();
        }, options);
        window.addEventListener('resize', () => this.position(), options);
        window.addEventListener('scroll', () => this.position(), { ...options, capture: true, passive: true });
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        clearTimeout(this.hideTimer);
        this.timingPanel?.remove();
      }

      show() {
        clearTimeout(this.hideTimer);
        this.timingPanel.hidden = false;
        this.toggle.setAttribute('aria-expanded', 'true');
        this.position();
      }

      hide() {
        clearTimeout(this.hideTimer);
        this.pinned = false;
        this.timingPanel.hidden = true;
        this.toggle.setAttribute('aria-expanded', 'false');
      }

      scheduleHide() {
        clearTimeout(this.hideTimer);
        this.hideTimer = setTimeout(() => {
          if (!this.pinned && document.activeElement !== this.toggle) this.hide();
        }, 120);
      }

      position() {
        if (this.timingPanel.hidden) return;
        const anchor = this.toggle.getBoundingClientRect();
        if (anchor.bottom <= 0 || anchor.top >= window.innerHeight) {
          this.hide();
          return;
        }
        const bounds = this.timingPanel.getBoundingClientRect();
        const margin = 12;
        const gap = 10;
        const left = Math.max(margin, Math.min(anchor.right - bounds.width, window.innerWidth - bounds.width - margin));
        const above = anchor.bottom + gap + bounds.height > window.innerHeight - margin && anchor.top > bounds.height + gap;
        const top = above ? anchor.top - gap - bounds.height : anchor.bottom + gap;
        const arrow = Math.max(14, Math.min(anchor.left + anchor.width / 2 - left, bounds.width - 14));
        this.timingPanel.style.left = `${left}px`;
        this.timingPanel.style.top = `${Math.max(margin, top)}px`;
        this.timingPanel.style.setProperty('--timing-arrow-left', `${arrow}px`);
        this.timingPanel.dataset.placement = above ? 'above' : 'below';
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-jacket-size-chart"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('jacket-size-guide')) {
    customElements.define('jacket-size-guide', class extends HTMLElement {
      connectedCallback() {
        if (this.chartInitialized) return;
        this.chartInitialized = true;
        this.addEventListener('click', (event) => {
          const chartButton = event.target.closest('[data-jacket-chart]');
          if (chartButton && this.contains(chartButton)) {
            const chart = chartButton.dataset.jacketChart;
            this.querySelectorAll('[data-jacket-chart]').forEach((button) => {
              const active = button === chartButton;
              button.classList.toggle('is-active', active);
              button.setAttribute('aria-pressed', String(active));
            });
            this.querySelectorAll('[data-jacket-panel]').forEach((panel) => {
              panel.hidden = panel.dataset.jacketPanel !== chart;
            });
            this.querySelectorAll('[data-jacket-reference-unit]').forEach((label) => {
              label.hidden = chart !== 'reference';
            });
          }
          const unitButton = event.target.closest('[data-jacket-unit]');
          if (unitButton && this.contains(unitButton)) {
            const unit = unitButton.dataset.jacketUnit;
            this.querySelectorAll('[data-jacket-unit]').forEach((button) => {
              const active = button === unitButton;
              button.classList.toggle('is-active', active);
              button.setAttribute('aria-pressed', String(active));
            });
            this.querySelectorAll('[data-unit-panel]').forEach((panel) => {
              panel.classList.toggle('is-active', panel.dataset.unitPanel === unit);
            });
          }
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-review-preview"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-review-preview')) {
    customElements.define('product-review-preview', class extends HTMLElement {
      connectedCallback() {
        this.list = this.querySelector('[data-review-list]');
        this.more = this.querySelector('[data-review-more]');
        this.status = this.querySelector('[data-review-status]');
        this.loadingLabel = this.status.textContent;
        this.onJump = this.jump.bind(this);
        this.more.addEventListener('click', this.onJump);
        this.observer = new MutationObserver(records => {
          const selector = '.jdgm-review-widget, .jdgm-rev-widg, .jm-review-widget, .jdgm-prev-badge';
          const relevant = records.some(record => {
            if (this.contains(record.target)) return false;
            const parent = record.target.nodeType === 1 ? record.target : record.target.parentElement;
            if (parent?.closest(selector)) return true;
            return [...record.addedNodes, ...record.removedNodes].some(node =>
              node.nodeType === 1 && (node.matches(selector) || node.querySelector(selector))
            );
          });
          if (relevant) this.schedule();
        });
        this.observer.observe(document.body, {
          childList: true, subtree: true, characterData: true, attributes: true,
          attributeFilter: ['data-average-rating', 'data-number-of-reviews', 'data-score', 'data-verified-buyer', 'aria-label']
        });
        this.sync();
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        cancelAnimationFrame(this.frame);
        this.more?.removeEventListener('click', this.onJump);
      }
      schedule() {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.sync());
      }
      findTarget() {
        const candidates = [...document.querySelectorAll('#judgeme_product_reviews, .jdgm-review-widget')];
        return candidates.find(node => node.dataset.id === this.dataset.productId)
          || candidates.find(node => !node.dataset.id && node.id === 'judgeme_product_reviews');
      }
      setRating(element, value) {
        const rating = Number.parseFloat(value);
        element.hidden = !Number.isFinite(rating) || rating <= 0 || rating > 5;
        if (element.hidden) return;
        if (element.children.length !== 5) {
          element.replaceChildren(...Array.from({ length: 5 }, () => {
            const star = document.createElement('span');
            star.className = 'product-review-preview__star';
            star.setAttribute('aria-hidden', 'true');
            return star;
          }));
        }
        [...element.children].forEach((star, index) => {
          star.style.setProperty('--review-star-fill', `${Math.max(0, Math.min(1, rating - index)) * 100}%`);
        });
        element.setAttribute('aria-label', this.dataset.ratingLabel.replace('[rating]', String(rating)));
      }
      text(node, selector) {
        const source = node.querySelector(selector);
        if (!source) return '';
        const content = source.cloneNode(true);
        content.querySelectorAll('img, picture, video, audio, iframe, svg, script, style').forEach(media => media.remove());
        content.querySelectorAll('br').forEach(line => line.replaceWith('\n'));
        content.querySelectorAll('p, li').forEach(block => block.append('\n'));
        return content.textContent.trim();
      }
      rating(node) {
        const stars = node.querySelector('.jdgm-rev__rating, .jm-star-rating');
        return stars?.getAttribute('data-score')
          ?? stars?.getAttribute('aria-label')?.match(/\d+(?:[.,]\d+)?/)?.[0]?.replace(',', '.');
      }
      reviews(target) {
        return [...target.querySelectorAll('.jdgm-rev, .jm-review-item')].map(node => ({
          author: this.text(node, '.jdgm-rev__author, .jm-reviewer-info__name'),
          title: this.text(node, '.jdgm-rev__title, .jm-review-content__title'),
          body: this.text(node, '.jdgm-rev__body, .jdgm-review-content__body-content'),
          rating: this.rating(node),
          verified: node.getAttribute('data-verified-buyer') === 'true'
            || !!node.querySelector('.jm-reviewer-info .jm-verified-badge')
        })).filter(review => review.title || review.body).slice(0, 3);
      }
      sync() {
        const target = this.findTarget();
        this.hidden = !target;
        if (!target) return;
        const summary = target.querySelector('.jdgm-rev-widg') || target;
        const badge = this.closest('[data-section-type="product"]')?.querySelector('.jdgm-prev-badge');
        const modernSummary = target.querySelector('.jm-average-rating-display');
        const modernCount = modernSummary?.textContent.match(/\(([\d\s.,]+)\s/)?.[1]?.replace(/[^\d]/g, '');
        const countValue = summary.getAttribute('data-number-of-reviews')
          ?? badge?.getAttribute('data-number-of-reviews') ?? modernCount;
        const count = countValue === null || countValue === undefined ? NaN : Number(countValue);
        const countElement = this.querySelector('[data-review-count]');
        countElement.hidden = !Number.isFinite(count);
        const countText = Number.isFinite(count) ? `(${count})` : '';
        if (countElement.textContent !== countText) countElement.textContent = countText;
        this.setRating(this.querySelector('[data-review-average]'),
          summary.getAttribute('data-average-rating') ?? badge?.getAttribute('data-average-rating')
            ?? (modernSummary ? this.rating(modernSummary) : undefined));
        const reviews = this.reviews(target);
        const signature = JSON.stringify(reviews);
        if (signature !== this.signature) {
          this.signature = signature;
          this.list.replaceChildren(...reviews.map(review => this.card(review)));
        }
        this.status.hidden = reviews.length > 0;
        const loaded = !!target.querySelector('.jdgm-review-list, .jdgm-rev-widg__reviews');
        const statusText = count === 0 ? this.dataset.emptyLabel
          : loaded ? this.dataset.noTextLabel : this.loadingLabel;
        if (this.status.textContent !== statusText) this.status.textContent = statusText;
        if (!target.id) target.id = `product-reviews-${this.dataset.productId}`;
        this.more.href = `#${target.id}`;
        this.more.hidden = false;
      }
      card(review) {
        const card = this.querySelector('[data-review-template]').content.firstElementChild.cloneNode(true);
        const avatar = card.querySelector('[data-review-avatar]');
        avatar.textContent = Array.from(review.author)[0]?.toUpperCase() || '•';
        if (review.verified) avatar.setAttribute('data-verified', '');
        card.querySelector('[data-review-author]').textContent = review.author;
        card.querySelector('[data-review-verified]').hidden = !review.verified;
        this.setRating(card.querySelector('[data-review-rating]'), review.rating);
        [['title', review.title], ['body', review.body]].forEach(([key, value]) => {
          const element = card.querySelector(`[data-review-${key}]`);
          element.hidden = !value;
          element.textContent = value.length > 360 ? `${value.slice(0, 357).trimEnd()}…` : value;
        });
        return card;
      }
      jump(event) {
        const target = this.findTarget();
        if (!target) { event.preventDefault(); this.sync(); return; }
        event.preventDefault();
        for (let parent = target.parentElement; parent; parent = parent.parentElement) {
          if (parent.tagName === 'DETAILS') parent.open = true;
        }
        if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
        target.focus({ preventScroll: true });
        target.scrollIntoView({
          behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          block: 'start'
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-silent-jacket-features"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('silent-jacket-features')) {
    customElements.define('silent-jacket-features', class extends HTMLElement {
      connectedCallback() {
        if (this.hasAttribute('data-enhanced')) return;
        this.slides = Array.from(this.querySelectorAll('.silent-jacket-features__slide'));
        this.steps = Array.from(this.querySelectorAll('[data-feature-index]'));
        this.previous = this.querySelector('[data-feature-previous]');
        this.next = this.querySelector('[data-feature-next]');
        this.current = this.querySelector('[data-feature-current]');
        this.index = 0;
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };

        this.previous.addEventListener('click', () => this.show(this.index - 1), options);
        this.next.addEventListener('click', () => this.show(this.index + 1), options);
        this.steps.forEach((step, index) => step.addEventListener('click', () => this.show(index), options));
        this.addEventListener('keydown', event => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          this.show(this.index + (event.key === 'ArrowRight' ? 1 : -1));
        }, options);
        this.addEventListener('touchstart', event => {
          if (event.touches.length !== 1 || event.target.closest('button')) {
            this.touchStart = null;
            return;
          }
          this.touchStart = { x: event.touches[0].clientX, y: event.touches[0].clientY };
        }, { ...options, passive: true });
        this.addEventListener('touchend', event => {
          if (!this.touchStart) return;
          const dx = event.changedTouches[0].clientX - this.touchStart.x;
          const dy = event.changedTouches[0].clientY - this.touchStart.y;
          this.touchStart = null;
          if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.2) {
            this.show(this.index + (dx < 0 ? 1 : -1));
          }
        }, { ...options, passive: true });
        this.addEventListener('touchcancel', () => { this.touchStart = null; }, options);

        this.setAttribute('data-enhanced', '');
        this.querySelector('.silent-jacket-features__controls').hidden = false;
        this.show(0);
      }

      disconnectedCallback() {
        this.abort?.abort();
        this.removeAttribute('data-enhanced');
      }

      show(index) {
        this.index = Math.max(0, Math.min(this.slides.length - 1, index));
        this.slides.forEach((slide, slideIndex) => { slide.hidden = slideIndex !== this.index; });
        this.steps.forEach((step, stepIndex) => {
          if (stepIndex === this.index) step.setAttribute('aria-current', 'step');
          else step.removeAttribute('aria-current');
        });
        this.current.textContent = String(this.index + 1);
        this.previous.disabled = this.index === 0;
        this.next.disabled = this.index === this.slides.length - 1;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-tree-skirt-size-chart"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tree-skirt-size-guide')) {
    customElements.define('tree-skirt-size-guide', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.querySelectorAll('[data-tree-skirt-shape-control]').forEach(button => {
          button.addEventListener('click', () => {
            this.querySelectorAll('[data-tree-skirt-shape-control]').forEach(control => {
              control.setAttribute('aria-pressed', String(control === button));
            });
            this.querySelectorAll('[data-tree-skirt-shape-panel]').forEach(panel => {
              panel.hidden = panel.dataset.treeSkirtShapePanel !== button.dataset.treeSkirtShapeControl;
            });
          });
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
